<template>
    <div class="animated fadeIn">
        <b-card class="piplines-list" :no-body="true">
            <b-card-header>
                <b-row>
                    <b-col cols="10">
                        <v-select
                            class="text-nowrap"
                            v-model="category"
                            label="name"
                            placeholder="Select Category"
                            :options="categories"
                            id="category-multiselect"
                        ></v-select>
                    </b-col>
                    <b-col cols="2">
                        <router-link to="/codelabs/categories/create">
                            <b-button :disabled="isViewer" class="text-nowrap" id="new-category-btn" variant="primary">
                                <i class="icon-plus mr-1"></i>Add new Category
                            </b-button>
                        </router-link>
                    </b-col>
                </b-row>
            </b-card-header>
        </b-card>
        <b-card class="piplines-list">
            <b-card-header class="card-header-main">
                <b-row class="piplines-list-header">
                    <div class="btn-row">
                        <router-link to="/codelabs/create">
                            <b-button :disabled="isViewer" class="text-nowrap" variant="primary">
                                <i class="icon-plus mr-1"></i> Add new Codelab
                            </b-button>
                        </router-link>
                        <b-button @click="refreshAll" class="text-nowrap" variant="primary">
                            <i class="fa fa-refresh mr-1"></i> Refresh All
                        </b-button>
                    </div>
                </b-row>
            </b-card-header>
            <b-card-body>
                <v-server-table
                    v-if="category"
                    class="server-table"
                    :url="apiUrl"
                    :columns="columns"
                    :options="options"
                    :theme="theme"
                    ref="codelabsTable"
                >
                    <div slot="actions" slot-scope="props" class="button-row">
                        <DetailsAction :routerLink="'codelabs/' + props.row.id" />
                        <RefreshAction :resource="props.row" :refreshResource="refreshCodelab" />
                        <OpenDocAction :resourceUrl="props.row.docUrl" />
                        <OpenCodelabAction :resourceUrl="getCodelabUrl(props.row.id)" />
                    </div>
                </v-server-table>
                <div v-else class="small-info-text">Select a Category first to view the list of Codelabs</div>
            </b-card-body>
        </b-card>

        <Loading :loading="$store.state.loading.processing" :text="$store.state.loading.text"></Loading>
        <Success />
    </div>
</template>

<script>
import store from '../../store/index'
import Vue from 'vue'
import EventBus from '../../eventBus'

import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'

import Loading from '@/components/loading.vue'
import Feedback from '@/components/Feedback.vue'
import Success from '@/components/Success.vue'

import DetailsAction from '@/components/Actions/DetailsAction.vue'
import RefreshAction from '@/components/Actions/RefreshAction.vue'
import OpenDocAction from '@/components/Actions/OpenDocAction.vue'
import OpenCodelabAction from '@/components/Actions/OpenCodelabAction.vue'

import {ServerTable} from 'vue-tables-2'
Vue.use(ServerTable)

import {mapGetters} from 'vuex'

import VueNotifications from 'vue-notifications'

export default {
    components: {
        ServerTable,
        Loading,
        Success,
        DetailsAction,
        RefreshAction,
        OpenDocAction,
        OpenCodelabAction,
    },
    notifications: {
        pipelineCreated: {
            type: VueNotifications.types.success,
            title: 'Pipeline has been successfully created.',
        },
        pipelineUpdated: {
            type: VueNotifications.types.success,
            title: 'Pipeline has been successfully updated.',
        },
    },
    methods: {
        reloadTable() {
            if (!document.hidden && this.$refs.codelabsTable) this.$refs.codelabsTable.getData()
        },
        checkNotifications() {
            const {pipelineCreated, pipelineUpdated} = this.$route.query

            if (pipelineCreated) {
                this.$router.replace({query: {}})
                this.pipelineCreated()
            }

            if (pipelineUpdated) {
                this.$router.replace({query: {}})
                this.pipelineUpdated()
            }
        },
        refreshCodelab(codelab) {
            this.$store.commit('loading/PROCESSING', `Refreshing the Codelab...`)
            this.$store
                .dispatch('codelab/refreshCodelab', codelab.id)
                .then(category => {
                    this.$store.commit('loading/PROCESSED')
                    this.$store.commit('success/SHOW')
                })
                .catch(exception => {
                    this.$store.commit('loading/PROCESSED')
                })
        },
        refreshAll() {
            this.$store.commit('loading/PROCESSING', `Refreshing All Codelabs in the Project...`)
            this.$store
                .dispatch('codelab/refreshAll', this.activeProject.id)
                .then(category => {
                    this.$store.commit('loading/PROCESSED')
                    this.$store.commit('success/SHOW')
                })
                .catch(exception => {
                    this.$store.commit('loading/PROCESSED')
                })
        },
        getCodelabUrl(id) {
            if (process.env.VUE_APP_MODE === 'local') {
                return `${process.env.VUE_APP_NODE_API_HOST}/codelabs/${id}`
            } else {
                return `https://${this.activeProject.domain}/${id}`
            }
        },
    },
    async created() {
        this.checkNotifications()
        if (!this.category) {
            const categories = await this.$store.dispatch('category/getCategories', this.activeProject.id)
            if (categories && categories.length > 0) {
                this.$store.commit('category/SET_CATEGORY', categories[0])
            }
        }
    },
    mounted() {
        setInterval(this.reloadTable, 10000)
    },
    computed: {
        ...mapGetters({
            activeProject: 'project/active',
            categories: 'category/categories',
        }),
        isViewer() {
            return this.activeProject.role == 'Viewer'
        },
        category: {
            get() {
                return this.$store.state.category.active
            },

            set(value) {
                this.$store.commit('category/SET_CATEGORY', value)
                this.reloadTable()
            },
        },
    },
    data() {
        return {
            codelabsError: {
                state: true,
                message: '',
            },
            apiUrl: `${process.env.VUE_APP_NODE_API_HOST}/codelabs`,
            columns: ['name', 'actions'],
            options: {
                requestFunction: function(data) {
                    return this.axios
                        .get(this.url, {
                            params: {
                                ...data,
                                categoryId: this.$store.state.category.active.id,
                            },
                        })
                        .catch(
                            function(e) {
                                this.dispatch('error', e)
                            }.bind(this)
                        )
                },
                responseAdapter: function(resp) {
                    const data = resp.data
                    return {
                        data: data.data,
                        count: data.metadata.count,
                    }
                },
                orderBy: {
                    ascending: false,
                },
                childRowTogglerFirst: false,
                filterable: false,
                sortable: [],
                rowClassCallback: () => 'main-row',
            },
            useVuex: false,
            theme: 'bootstrap4',
            template: 'default',
            showSuccess: false,
        }
    },
}
</script>

<style <style lang="scss">
#new-category-btn {
    margin-top: 3px;
}
</style>
